import { render, staticRenderFns } from "./FieldNameLabel.vue?vue&type=template&id=66e8b5be&"
import script from "./FieldNameLabel.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FieldNameLabel.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FieldNameLabel.vue?vue&type=style&index=0&id=66e8b5be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports